import { useEffect } from "react";
import { useStytchSession, useStytch } from "@stytch/react";
import { useNavigate } from "react-router-dom";
import { Spinner, Center } from "@chakra-ui/react";
import useQueryParams from "../../hooks/useQueryParams";
import { ROUTES } from "../../config/routes";

const Authenticate = (): JSX.Element => {
  const stytch = useStytch();
  const { session } = useStytchSession();
  const navigate = useNavigate();

  const { token } = useQueryParams(["token"]);

  useEffect(() => {
    const authenticateUser = async () => {
      if (session) return navigate(ROUTES.DASHBOARD.HOME);
      if (!token) return navigate(ROUTES.AUTH.LOGIN);

      try {
        await stytch.magicLinks.authenticate(token, {
          session_duration_minutes: 20160,
        });
        navigate(ROUTES.DASHBOARD.HOME);
      } catch (error) {
        console.error(error);
        navigate(ROUTES.AUTH.LOGIN);
      }
    };

    authenticateUser();
  }, [stytch, session, navigate, token]);

  return (
    <Center height="100vh">
      <Spinner size="xl" />
    </Center>
  );
};

export default Authenticate;
